import React, {useContext} from "react"
import {ChartScopeSettings, getChartScopeDisplayValue, getDateRange} from "./chart-scope-settings/chart-scope-settings"
import {MonthlySpendingData} from "../../../services/api/insight-api"
import {CategoryHelper, CategoryHelperContext} from "../../../services/helpers/category-helper"
import {Transactions} from "../transactions/transactions"
import {TransactionRange} from "../../../domain/transaction-range"
import {ResetCategoryScope} from "../transactions/transactions-view"

interface ChartScopeTransactionsProps {
  chartScopeSettings: ChartScopeSettings
  monthlySpendingData: MonthlySpendingData
  categoryId?: number
  setCategoryId: (categoryId: number) => void
  impactFirst: boolean
  refreshSpendingData: () => void
  transactionRange: TransactionRange | null
  displayCategoryScope?: boolean
  showFilter?: boolean
  resetCategoryScope?: ResetCategoryScope
  doNotShowIncome?: boolean
}

export const ChartScopeTransactions : React.FC<ChartScopeTransactionsProps> = ({ chartScopeSettings, monthlySpendingData, categoryId, setCategoryId, impactFirst, refreshSpendingData, transactionRange, displayCategoryScope, showFilter = true, resetCategoryScope, doNotShowIncome}) => {
  const categoryHelper = useContext<CategoryHelper | null>(CategoryHelperContext)

  if (categoryHelper === null) return null

  let [transactionsFrom, transactionsUntil] = getDateRange(chartScopeSettings.range, transactionRange)

  // set from and until if date boundaries are crossed
  if (transactionsFrom === null || (monthlySpendingData.from && transactionsFrom < monthlySpendingData.from)) transactionsFrom = monthlySpendingData.from ?? null
  if (transactionsUntil === null || (monthlySpendingData.until && transactionsUntil > monthlySpendingData.until)) transactionsUntil = monthlySpendingData.until ?? null

  let scopeDisplay = getChartScopeDisplayValue(chartScopeSettings)
  if (displayCategoryScope && categoryId) scopeDisplay += ` (${categoryHelper.getCategoryName(categoryId)})`

  return <Transactions categoryId={categoryId} setCategoryId={setCategoryId} from={transactionsFrom} until={transactionsUntil} scopeDisplay={scopeDisplay} refreshSpendingData={refreshSpendingData} impactFirst={impactFirst} showFilter={showFilter} resetCategoryScope={resetCategoryScope} doNotShowIncome={doNotShowIncome}/>
}